import { useEffect } from "react";
import Lenis from "lenis";
import { BookingProvider } from "@/site/BookingContext";
import Nav from "@/site/Nav";
import Hero from "@/site/Hero";
import ManifestoReveal from "@/site/ManifestoReveal";
import ProblemSection from "@/site/ProblemSection";
import HiddenCosts from "@/site/HiddenCosts";
import FormulaReveal from "@/site/FormulaReveal";
import FormulaCards from "@/site/FormulaCards";
import Lifestyle from "@/site/Lifestyle";
import CaseStudies from "@/site/CaseStudies";
import Stats from "@/site/Stats";
import Founder from "@/site/Founder";
import Philosophy from "@/site/Philosophy";
import WhoFor from "@/site/WhoFor";
import WhoNotFor from "@/site/WhoNotFor";
import Journey from "@/site/Journey";
import SocialProof from "@/site/SocialProof";
import FinalCTA from "@/site/FinalCTA";
import Footer from "@/site/Footer";
import BookingModal from "@/site/BookingModal";
import StickyMobileCTA from "@/site/StickyMobileCTA";

function App() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });

    let rafId;
    function raf(time) {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    }
    rafId = requestAnimationFrame(raf);

    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <BookingProvider>
      <div className="relative bg-warm font-body text-ink">
        <Nav />
        <main>
          <Hero />
          <ManifestoReveal />
          <ProblemSection />
          <HiddenCosts />
          <FormulaReveal />
          <FormulaCards />
          <Lifestyle />
          <CaseStudies />
          <Stats />
          <Founder />
          <Philosophy />
          <WhoFor />
          <WhoNotFor />
          <Journey />
          <SocialProof />
          <FinalCTA />
        </main>
        <Footer />
        <BookingModal />
        <StickyMobileCTA />
      </div>
    </BookingProvider>
  );
}

export default App;
